import { useMemo } from 'react';
import { performanceSettings } from '../utils/smoothTransitions';

export const useOptimizedAnimation = () => {
  const shouldReduceMotion = useMemo(() => {
    return performanceSettings.respectMotionPreference();
  }, []);

  const getOptimizedVariants = (variants) => {
    if (shouldReduceMotion) {
      return performanceSettings.reducedMotion;
    }
    return variants;
  };

  const getOptimizedTransition = (transition) => {
    if (shouldReduceMotion) {
      return { duration: 0.2 };
    }
    return transition;
  };

  return {
    shouldReduceMotion,
    getOptimizedVariants,
    getOptimizedTransition
  };
};